<template>
    <div>
      <!-- Exibe o LoadingSpinner enquanto isLoading for true -->
      <div v-if="isLoading">
        <LoadingSpinner />
      </div>
      <!-- Quando não estiver carregando, exibe o conteúdo -->
      <div v-else>
        <div v-if="periodoData" class="card card-body shadow-sm mt-0">
          <div class="header d-flex justify-content-between align-items-center">
            <h4 class="form-title">
              Detalhes do Período de Avaliação:
              <span v-if="periodoData.id">{{ periodoData.id }}</span>
            </h4>
            <button class="btn btn-secondary" @click="voltar">Voltar</button>
          </div>
    
          <!-- Seção 1: Dados da Avaliação -->
          <div class="form-content mt-3">
            <FormSection title="Dados da Avaliação">
              <p><strong>Avaliação:</strong> {{ periodoData.nome }}</p>
              <p><strong>Início:</strong> {{ globalUtils.formatarData(periodoData.data_inicio) }}</p>
              <p><strong>Fim:</strong> {{ globalUtils.formatarData(periodoData.data_fim) }}</p>
              <p><strong>Aplicada:</strong> {{ periodoData.aplicada ? 'Sim' : 'Não' }}</p>
            </FormSection>
          </div>
    
          <!-- Seção 2: Níveis e Formulários de Prova -->
          <div class="form-content mt-3">
            <FormSection title="Níveis e Formulários de Prova">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nível</th>
                    <th>Formulário de Prova</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(assoc, index) in associacoesDetalhadas" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ assoc.nivelNome }}</td>
                    <td>{{ assoc.formularioNome }}</td>
                  </tr>
                  <tr v-if="associacoesDetalhadas.length === 0">
                    <td colspan="3" class="text-center">Nenhum nível registrado.</td>
                  </tr>
                </tbody>
              </table>
            </FormSection>
          </div>
        </div>
        <div v-else>
          <p>Nenhum período de avaliação encontrado.</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import axios from '@/services/axios';
  import FormSection from '@/components/Layout/FormSection.vue';
  import globalUtils from "@/utils/globalUtils.js";
//   import LoadingSpinner from '@/components/LoadingSpinner.vue'; // Certifique-se de que o LoadingSpinner está disponível
  
  export default {
    name: 'DetalharPeriodoAvaliacao',
    components: {
      FormSection,
    //   LoadingSpinner,
    },
    setup() {
      const route = useRoute();
      const router = useRouter();
      const isLoading = ref(true);
      const periodoData = ref(null);
      const associacoesDetalhadas = ref([]);
  
      // Mapeamentos para associar IDs com os nomes
      const niveisMap = ref({});
      const formulariosMap = ref({});
  
      // Carregar os mapeamentos dos níveis (ativos) e formulários de prova
      const carregarMappings = async () => {
        try {
          // Carregar níveis ativos
          const niveisResponse = await axios.get('/cadastros/niveis-turmas/todos', {
            params: { ativo: true }
          });
          if (niveisResponse.data.data && Array.isArray(niveisResponse.data.data)) {
            niveisResponse.data.data.forEach(nivel => {
              niveisMap.value[nivel.id] = nivel.nivel;
            });
          }
          // Carregar formulários de prova
          const formulariosResponse = await axios.get('/configuracoes/formularios-avaliacoes/todos');
          if (formulariosResponse.data.data && Array.isArray(formulariosResponse.data.data)) {
            formulariosResponse.data.data.forEach(form => {
              formulariosMap.value[form.id] = form.formulario;
            });
          }
        } catch (error) {
          console.error("Erro ao carregar mappings:", error);
        }
      };
  
      // Carregar os dados do período e "enriquecer" as associações com os nomes
      const carregarPeriodo = async (id) => {
        try {
          const response = await axios.get(`/cadastros/avaliacoes-periodos/${id}`);
          periodoData.value = response.data;
          
          if (periodoData.value.niveis && Array.isArray(periodoData.value.niveis)) {
            associacoesDetalhadas.value = periodoData.value.niveis.map(assoc => {
              return {
                nivelNome: niveisMap.value[assoc.nivel_id] || `ID: ${assoc.nivel_id}`,
                formularioNome: formulariosMap.value[assoc.avaliacoes_formularios_id] || `ID: ${assoc.avaliacoes_formularios_id}`
              };
            });
          } else {
            associacoesDetalhadas.value = [];
          }
        } catch (error) {
          console.error("Erro ao carregar período:", error);
        } finally {
          isLoading.value = false;
        }
      };
  
      const voltar = () => {
        router.push("/cadastros/avaliacoes-periodos");
      };
  
      onMounted(async () => {
        await carregarMappings();
        if (route.params.id) {
          await carregarPeriodo(route.params.id);
        } else {
          isLoading.value = false;
        }
      });
  
      return { 
        isLoading,
        periodoData, 
        associacoesDetalhadas, 
        voltar, 
        globalUtils,
      };
    }
  };
  </script>
  
  <style scoped>
  .card {
    margin: 20px;
  }
  .form-title {
    font-size: 1.25rem;
    font-weight: bold;
  }
  </style>
  